import { Injectable } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { ICRUDOptions } from '@phx-erp/shared';
import { BaseListService } from "../../../@core/services/base-list.service";
import { SystemService } from "../../../@core/services/system.service";
import { DELETE_TAXONOMY_CATEGORY, GET_TAXONOMY_CATEGORIES, GET_TAXONOMY_CATEGORY, SAVE_TAXONOMY_CATEGORY } from "../../../data/definitions/taxonomy-category.definition";
import { BaseDataService } from "../../../data/services/base-data.service";
import { DataService } from "../../../data/services/data.service";
import { DeleteTaxonomyCategoryMutation, DeleteTaxonomyCategoryMutationVariables, DeletionResponse, GetTaxonomyCategoriesQuery, GetTaxonomyCategoriesQueryVariables, GetTaxonomyCategoryQuery, GetTaxonomyCategoryQueryVariables, SaveTaxonomyCategoryMutation, SaveTaxonomyCategoryMutationVariables, SearchInput, TaxonomyCategory, TaxonomyCategoryInput } from "../../../generated/generated-types";

@Injectable({
    providedIn: 'root'
})
export class TaxonomyCategoryService extends BaseListService<TaxonomyCategory> {

    constructor(private dataService: DataService,
        private baseDataService: BaseDataService,
        private systemService: SystemService) {
        super();
    }

    getItems(searchInput?: SearchInput, o?: ICRUDOptions) {
        let fragment = GET_TAXONOMY_CATEGORIES;

        if (o?.currentColumnConfig) {
            this.onlyKeepSelectedGraphQLNodesNew(fragment, o.currentColumnConfig.baseView, o.currentColumnConfig.columns);
        }

        return this.baseDataService.query<GetTaxonomyCategoriesQuery, GetTaxonomyCategoriesQueryVariables>(
            fragment, {
            input: searchInput as any
        });
    }

    getItem(id: string) {
        return this.baseDataService.query<GetTaxonomyCategoryQuery, GetTaxonomyCategoryQueryVariables>(
            GET_TAXONOMY_CATEGORY, {
            id: id
        });
    }

    getItemStream(id: string) {
        return this.getItem(id).mapStream(x => x.getTaxonomyCategory);
    }

    async getItemData(id: string): Promise<TaxonomyCategory> {
        let l = await lastValueFrom(this.getItem(id).single$);
        return l.getTaxonomyCategory as TaxonomyCategory;
    }

    async deleteItem(id: string): Promise<DeletionResponse> {
        let res = await lastValueFrom(this.baseDataService.mutate<DeleteTaxonomyCategoryMutation, DeleteTaxonomyCategoryMutationVariables>(
            DELETE_TAXONOMY_CATEGORY, {
            id: id
        }));

        return res.deleteTaxonomyCategory;
    }

    async saveItem(taxonomyCategory: TaxonomyCategory | TaxonomyCategoryInput) {
        let validated = await this.systemService.validateObject<TaxonomyCategoryInput>(taxonomyCategory, "TaxonomyCategoryInput");

        let saved = await lastValueFrom(this.baseDataService.mutate<SaveTaxonomyCategoryMutation, SaveTaxonomyCategoryMutationVariables>(
            SAVE_TAXONOMY_CATEGORY, {
            input: validated
        }));

        return saved.saveTaxonomyCategory as TaxonomyCategory;
    }
}
